<div class="modal-header">
  <h4 class="modal-title">Export check-ins</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
  <div class="mb-3" *ngIf="memberName">
    <div class="text-muted small">Export check-ins for {{ memberName }}</div>
  </div>

  <form [formGroup]="exportForm" class="export-form">
    <div class="mb-3">
      <h6 class="mb-2">Date Range</h6>
      <div class="row g-2">
        <div class="col-12 col-md-6">
          <label class="form-label">Start Date</label>
          <input type="date" class="form-control" formControlName="startDate" />
        </div>
        <div class="col-12 col-md-6">
          <label class="form-label">End Date</label>
          <input type="date" class="form-control" formControlName="endDate" />
        </div>
      </div>
    </div>

    <div class="mb-2">
      <h6 class="mb-2">Export Format</h6>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="formatPdfCheckins" value="pdf" formControlName="format" />
        <label class="form-check-label" for="formatPdfCheckins">PDF</label>
      </div>
      <div class="form-check">
        <input class="form-check-input" type="radio" id="formatCsvCheckins" value="csv" formControlName="format" />
        <label class="form-check-label" for="formatCsvCheckins">CSV</label>
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
  <button type="button" class="btn btn-primary" (click)="export()" [disabled]="!exportForm.valid">Export</button>
</div>
